import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useCallback } from 'react';
import { extractDataFromDOMEvent } from '../../utils/extractDataFromDOMEvent';
import { useCommonDatePickerSelectionEvents } from '../../hooks/useCommonDatePickerSelectionEvents';
export var useDatePickerSelectionEvents = function useDatePickerSelectionEvents(_ref, _ref2) {
  var value = _ref.value,
    onChange = _ref.onChange,
    enableCloseOnSelect = _ref.enableCloseOnSelect,
    closeDropdown = _ref.closeDropdown,
    isDateSelectable = _ref.isDateSelectable,
    enableTimePicker = _ref.enableTimePicker,
    timeSelectorValue = _ref.timeSelectorValue;
  var onDayMouseEnter = _ref2.onDayMouseEnter,
    onDayMouseLeave = _ref2.onDayMouseLeave;
  var onClick = useCallback(function (event) {
    var data = extractDataFromDOMEvent(event);
    if (!data) {
      return;
    }
    var vector = data.vector,
      displayedMonth = data.displayedMonth;
    var selectable = isDateSelectable(vector);
    if (!displayedMonth || !selectable) {
      return;
    }
    var resultVector = vector;
    // copy time from the existing value, if there is something
    if (value.dateStart) {
      var _value$dateStart = value.dateStart,
        minute = _value$dateStart.minute,
        hour = _value$dateStart.hour;
      resultVector = resultVector.clone({
        minute: minute,
        hour: hour
      });
    } else if (enableTimePicker) {
      var _minute = timeSelectorValue.minute,
        _hour = timeSelectorValue.hour;
      resultVector = resultVector.clone({
        minute: _minute,
        hour: _hour
      });
    }
    onChange(value.clone({
      dateStart: resultVector,
      dateEnd: resultVector
    }));
    if (enableCloseOnSelect) {
      closeDropdown();
    }
  }, [isDateSelectable, value, onChange, enableCloseOnSelect, closeDropdown, enableTimePicker, timeSelectorValue]);
  var commonEvents = useCommonDatePickerSelectionEvents({
    onDayMouseEnter: onDayMouseEnter,
    onDayMouseLeave: onDayMouseLeave
  });
  return {
    dayButtonProps: _objectSpread({
      onClick: onClick
    }, commonEvents.dayButtonProps),
    selectionStartCandidate: null,
    selectionEndCandidate: null
  };
};